import React, { useCallback, useEffect, useState } from 'react'
import { Loader } from 'src/components/shared/Loader'
import { cacheWebImages } from '../utils/cacheHelper'

import landingBg from '../images/pve/landing_bg.jpg'
import landingBgMobile from '../images/pve/landing_bg_mobile.png'
import masthead from '../images/ntc/landing/masthead.png'
import mastheadMobile from '../images/ntc/landing/masthead-mobile.png'
import headerOrganizer from '../images/ntc/landing/header-logo.png'
import loginBg from '../images/ntc/login/login-bg.webp'
import lobbyBg from '../images/pve/lobby-bg.webp'
import lobbyHelpDeskIcon from '../images/ntc/lobby/helpdesk-icon.png'
import agendaIcon from '../images/ntc/lobby/agenda-icon.png'
import speakerIcon from '../images/ntc/lobby/speaker-icon.png'
import hallIcon from '../images/ntc/lobby/hall-icon.png'
import galleryIcon from '../images/ntc/lobby/gallery-icon.png'
import surveyIcon from '../images/ntc/lobby/survey-icon.png'
import lobbyGuide from '../images/ntc/lobby/guide.jpg'
import mobileAuditoriumIcon from '../images/ntc/lobby/mobile-plenary.png'
import mobileAgenda from '../images/ntc/lobby/mobile-agenda.png'
import mobileGallery from '../images/ntc/lobby/mobile-gallery.png'
import mobileSurvey from '../images/ntc/lobby/mobile-survey.png'
import mobileHelp from '../images/ntc/lobby/mobile-help.png'
import auditoriumBg from '../images/pve/auditorium/auditorium-bg.jpg'
import auditoriumBanner from '../images/ntc/auditorium/banner.png'
import mobileAuditoriumBg from '../images/ntc/auditorium/mobile-auditorium.webp'
import hallMasthead from '../images/ntc/auditorium/hall-masthead-mobile.png'
import speakerHeader from '../images/ntc/general/speaker-header.png'
import programme1 from '../images/ntc/programme/NTC2025-DAY1.jpg'
import programme2 from '../images/ntc/programme/NTC2025-DAY2.jpg'
import galleryBg from '../images/pve/gallery/gallery-bg.png'
import galleryMasthead from '../images/ntc/gallery/masthead.png'
import galleryBg2 from '../images/pve/gallery/gallery-bg.jpg'
import videoIcon from '../images/pve/gallery/video-icon.png'
import folderIcon from '../images/ntc/gallery/folder.png'
import docIcon from '../images/pve/gallery/pdf-icon.png'
import posterIcon from '../images/pve/gallery/image-icon.png'  
import headerLogo from '../images/pve/kv.png'
import principalLogo from '../images/pve/principal-logo.png'
import countdownKv from '../images/pve/countdown-kv.png'
import countdownKvMobile from '../images/pve/countdown-kv-mobile.png'


import playBtn from '../images/ntc/lobby/play-btn.png'
import mobileBg from '../images/pve/mobile-bg.png'
import hallBanner from '../images/pve/auditorium/hall-banner.png'
import userGuideBtn from '../images/ntc/lobby/user-guide-btn.png'
import kvMobile from '../images/pve/kv_mobile.png'
import networkingIcon from '../images/ntc/lobby/networking-icon.png'
import gameIcon from '../images/ntc/lobby/game-icon.png'
import scrollRightIcon from '../images/pve/icons/custom-right-icon.png'
import gameBgMobile from '../images/game/game-bg-mobile.jpg'
import gameBg from '../images/game/game-bg.png'
import luckyDrawBg from '../images/pve/lucky-draw-bg.png'
import lobbyBgMobile from '../images/pve/lobby-bg-mobile.jpg'


export const fixedAssets = {
  headerOrganizer,
  auditoriumBanner,
  speakerHeader,
  programme1,
  programme2,
  folderIcon,
  videoIcon,
  docIcon,
  posterIcon,
  playBtn,
  principalLogo,
}

export const desktopAssets = {
  luckyDrawBg,
  countdownKv,
  hallBanner,
  landingBg,
  masthead,
  galleryMasthead,
  galleryBg,
  loginBg,
  lobbyBg,
  lobbyHelpDeskIcon,
  agendaIcon,
  lobbyGuide,
  speakerIcon,
  hallIcon,
  galleryIcon,
  surveyIcon,
  auditoriumBg,
  galleryBg2,
  userGuideBtn,
  networkingIcon,
  gameIcon,
  headerLogo,
  gameBg,
  
}

export const mobileAssets = {
  landingBgMobile,
  landingBg,
  mastheadMobile,
  mobileAuditoriumIcon,
  mobileAgenda,
  mobileGallery,
  mobileSurvey,
  mobileHelp,
  mobileAuditoriumBg,
  hallMasthead,
  kvMobile,
  mobileBg,
  scrollRightIcon,
  countdownKvMobile,
  lobbyBgMobile,

  // Game
  gameBgMobile,

}

export const PreCache = ({ deviceType, children }) => {
  const [pageLoading, setPageLoading] = useState(false)

  const preloadAssets = useCallback(async () => {
    setPageLoading(true)
    await cacheWebImages(
      Object.values({
        ...fixedAssets,
        ...(deviceType === 'desktop' ? desktopAssets : mobileAssets),
      })
    )
    setPageLoading(false)
  }, [])

  useEffect(() => {
    preloadAssets()
  }, [deviceType, preloadAssets])

  return (
    <Loader loading={pageLoading} fullPage>
      <>{children}</>
    </Loader>
  )
}
